import { gsap, TweenMax, TweenLite, DrawSVGPlugin, ScrollTrigger } from 'gsap/all';
gsap.registerPlugin(ScrollTrigger, TweenMax, TweenLite, DrawSVGPlugin);

/**
 * Hamburger animatie 
 * 
 * 1. Animeer hamburger naar kruisje
 * 2. Zet de contentlaag voor het menu aan
 * 
*/

export function mobileNavigation() {
  let toggle = document.querySelector('.hamburger');
  let body = document.querySelector('body')
  // let navContainer = document.querySelector('.mobile-navigation-container')
  let bool = false;
  //let myDiv = document.getElementsByClassName('nav-primary-indrukwekkend');
  //let list = myDiv.querySelectorAll(':scope > li');
  //let myDiv2 = document.getElementsByClassName('nav-top-indrukwekkend');
  //let list2 = myDiv2.querySelectorAll(':scope > li');
  let tl = gsap.timeline({defaults: {ease: 'power2.inOut', duration: 0.5 }})
  toggle.addEventListener('click', function () {
    console.log('click');
    if (bool === false) {
      body.classList.add('stop-scroll');
      tl.timeScale( 1 ); 
      tl.restart();
      tl.to('.bar1', { duration:.1, width:'45px', height: '4px', top:'45%' , left:'15%', rotate: '45deg' })
      .to('.bar2', { duration:.1, opacity: 0 }, '<' )
      .to('.bar3', { duration:.1, width:'45px', height: '4px', top:'45%' , left:'15%', rotate: '-45deg'}, '<')
      .to('.mobile-navigation-container', { duration: 0, width: '100%', ease: 'power4.in' }, '<')
      //.to( list, {duration: .1, opacity: 1, stagger: .05 })
      //.to( list2, {duration: .1, opacity: 1, stagger: .05 })
      bool = true;
    } else {
      body.classList.remove('stop-scroll');
      tl.timeScale( 1.5 ); 
      tl.reverse(.1);
      bool = false;
    }
  })
}

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.saveStyles('.mobile, .desktop');
ScrollTrigger.matchMedia({
  // tablet
  '(min-width: 782px)': function() {
    // Hide top-menu on scroll
    const showAnim = gsap.from('header .header', { 
      yPercent: -35,
      duration: 0.5,
    }).progress(1);
    const logoShrink = gsap.from('img.custom-logo', {
      xPercent: 0,
      yPercent: 40,
      scale: 0.9,
      duration: 0.5,
    }).progress(1);
    ScrollTrigger.create({
      start: 'top top',
      end: 'max',
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse()
        self.direction === -1 ? logoShrink.play() : logoShrink.reverse()
      },
    });
  },
  // mobile
  '(max-width: 781px)': function() {
    const logoShrink = gsap.from('img.custom-logo', {
      xPercent: 0,
      yPercent: 0,
      scale: 1,
      duration: 0,
    }).progress(1);
    ScrollTrigger.create({
      start: 'top top',
      end: 'max',
      onUpdate: (self) => {
        self.direction === -1 ? logoShrink.play() : logoShrink.reverse()
      },
    });
  },
});
